var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32586 11.6719L4.16659 8.66837V7.99598C4.16659 5.59757 5.63462 3.44359 7.86695 2.5666C9.23793 2.028 10.7619 2.028 12.1329 2.5666C14.3652 3.44359 15.8333 5.59757 15.8333 7.99598V8.66837L15.674 11.6719C15.5342 14.3067 13.899 16.6292 11.4654 17.649C10.5279 18.0418 9.47192 18.0418 8.53439 17.649C6.10086 16.6292 4.46559 14.3067 4.32586 11.6719Z",
    stroke: "#939393",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 14.1667H9.16659",
    stroke: "#939393",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.8333H7.58333",
    stroke: "#939393",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.8333H12.5833",
    stroke: "#939393",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34255 12.1835C2.71886 11.9964 2.29175 11.4224 2.29175 10.7712C2.29175 9.86976 3.09349 9.17932 3.98497 9.31304L4.37508 9.37155L4.37508 12.4933L3.34255 12.1835Z",
    stroke: "#939393",
    strokeWidth: 1.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6574 12.1835C17.2811 11.9964 17.7083 11.4224 17.7083 10.7712C17.7083 9.86976 16.9065 9.17932 16.015 9.31304L15.6249 9.37155L15.6249 12.4933L16.6574 12.1835Z",
    stroke: "#939393",
    strokeWidth: 1.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 8.69045V7.99598C3.33325 5.25494 5.011 2.79324 7.56224 1.79097C9.12907 1.17543 10.8708 1.17543 12.4376 1.79097C14.9888 2.79324 16.6666 5.25494 16.6666 7.99598V8.69045H3.33325Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthy);
export default __webpack_public_path__ + "static/media/healthy.5e56613d79cc7035144bc066abed4c7a.svg";
export { ForwardRef as ReactComponent };